package com.nonopn.skywatcher.app.utils

import dev.icerock.moko.mvvm.viewmodel.ViewModel
import eu.codlab.sentry.wrapper.Sentry
import eu.codlab.viewmodel.launch
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.async
import kotlinx.coroutines.isActive

@Suppress("TooGenericExceptionCaught")
fun <T> safeExecute(
    onError: (Throwable) -> T? = { null },
    execute: () -> T
): T? = try {
    execute()
} catch (e: Throwable) {
    onError(e)
}

fun ViewModel.safeLaunch(
    onError: (Throwable) -> Unit = {
        if (it !is CancellationException) {
            Sentry.captureException(it)
        }
    },
    run: suspend CoroutineScope.() -> Unit
) = OriginalException().let { original ->
    launch(
        onError = { error ->
            error.addSuppressed(original)
            onError(error)
        },
        {
            isActive
            run()
        }
    )
}

fun ViewModel.safeAsync(
    onError: (Throwable) -> Unit = {
        if (it !is CancellationException) {
            Sentry.captureException(it)
        }
    },
    run: suspend CoroutineScope.() -> Unit
) = OriginalException().let { original ->
    viewModelScope.async {
        @Suppress("TooGenericExceptionCaught")
        try {
            isActive
            run()
        } catch (err: Throwable) {
            err.addSuppressed(original)

            onError(err)
        }
    }
}

class OriginalException : Exception()
